import { render, staticRenderFns } from "./Potential.vue?vue&type=template&id=443c58bb&scoped=true"
import script from "./Potential.vue?vue&type=script&lang=js"
export * from "./Potential.vue?vue&type=script&lang=js"
import style0 from "./Potential.vue?vue&type=style&index=0&id=443c58bb&prod&scoped=true&lang=css"
import style1 from "./Potential.vue?vue&type=style&index=1&id=443c58bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c58bb",
  null
  
)

export default component.exports